import { useState } from "react";
import { CreditCard, LogOut, Zap } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import PaymentForm from "@/components/PaymentForm";
import EmailVerificationStep from "@/components/EmailVerificationStep";

import { PLANS } from "@/lib/plans";

const PAYABLE_PLANS = ["basic", "premium", "semester", "year"];

export default function SubscriptionWall({ reason, user }) {
  const { logout } = useAuth();
  const [payPlan, setPayPlan] = useState(PAYABLE_PLANS.includes(user.plan) ? user.plan : "basic");

  if (user.plan_status === "pending_verification" || user.email_verified === false) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="subscription-wall">
        <div className="w-full max-w-lg space-y-5">
          <EmailVerificationStep email={user.email} onVerified={() => {}} />
          <button onClick={logout} data-testid="wall-logout-button"
            className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-emerald-800 mx-auto">
            <LogOut className="w-4 h-4" /> تسجيل الخروج
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="subscription-wall">
      <div className="w-full max-w-lg bg-white rounded-2xl border p-8 shadow-sm text-center space-y-5">
        <div className="w-14 h-14 rounded-2xl bg-amber-100 flex items-center justify-center mx-auto">
          <CreditCard className="w-7 h-7 text-amber-700" />
        </div>
        <h1 className="text-xl font-extrabold text-emerald-950">
          {reason === "expired" ? "انتهت صلاحية اشتراكك" : "اشتراكك بانتظار التفعيل"}
        </h1>
        <p className="text-sm text-slate-500 leading-7">
          {reason === "expired"
            ? "انتهت الفترة التجريبية أو مدة اشتراكك. جدّد اشتراكك بالبطاقة لمواصلة استخدام المنصة فوراً."
            : `تم إنشاء حسابك بنجاح — ${PLANS[user.plan]?.name || user.plan}. فعّل اشتراكك الآن بالدفع بالبطاقة:`}
        </p>

        <div className="text-right space-y-3" data-testid="wall-payment-section">
          <div className="grid grid-cols-2 gap-2">
            {PAYABLE_PLANS.map((p) => (
              <button key={p} type="button" onClick={() => setPayPlan(p)} data-testid={`wall-plan-${p}`}
                className={`rounded-xl border-2 p-3 text-sm font-bold transition-colors ${
                  payPlan === p ? "border-emerald-800 bg-emerald-50 text-emerald-950" : "border-slate-200 text-slate-500"}`}>
                {PLANS[p].name}
                <span className="block text-[11px] font-extrabold text-emerald-800 mt-0.5" data-testid={`wall-plan-price-${p}`}>{PLANS[p].priceLabel}</span>
                <span className="block text-[10px] font-normal text-slate-400">{PLANS[p].duration}</span>
              </button>
            ))}
          </div>
          <PaymentForm key={payPlan} plan={payPlan} />
          <p className="text-[11px] text-slate-400 text-center flex items-center justify-center gap-1">
            <Zap className="w-3.5 h-3.5 text-amber-500" /> يُفعَّل اشتراكك تلقائياً فور نجاح الدفع
          </p>
        </div>

        <button onClick={logout} data-testid="wall-logout-button"
          className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-emerald-800 mx-auto">
          <LogOut className="w-4 h-4" /> تسجيل الخروج
        </button>
      </div>
    </div>
  );
}
